module.exports = __webpack_public_path__ + "static/media/virtual-tour.007f63c2.svg";